import moment from 'moment'


export const isFilled = (value) => {
    if (value == null) return false
    if (typeof value === "string") return value.trim() !== ""
    if (Array.isArray(value)) return value.length > 0
    if (typeof value === "object") return Object.keys(value).length > 0
    return true
}


export const getCustomValue = (section, key, nullCase=null) => {
    if (section == null) return nullCase
    if (!isFilled(section[key])) return nullCase
    return section[key]
}


export const getCustomSection = (custom_data, key) => {
    if (custom_data == null) return null
    let section = custom_data[key]
    if (section == null || typeof section !== "object" || Array.isArray(section)) return null
    if (!hasContent(section)) return null
    return section
}


export const hasContent = (section) => {
    if (section == null) return false
    let values = Object.values(section)
    for (let i = 0; i < values.length; i++) {
        if (isFilled(values[i])) return true
    }
    return false
}


export const formatCustomDate = (value, nullCase=null) => {
    if (!isFilled(value)) return nullCase
    let date = moment(value)
    if (!date.isValid()) return value.toString()
    return date.format("DD/MM/YYYY")
}


export const formatCount = (value, singular, plural, nullCase=null) => {
    if (!isFilled(value)) return nullCase
    if (isNaN(value)) return value.toString()
    return Number(value) === 1 ? value + " " + singular : value + " " + plural
}
